import React, {useState, useEffect, useContext, Fragment} from 'react'

import {StorageContext} from '../context'

const FavoriteHeart = ({id, children}) => {
  const storage = useContext(StorageContext);

  const [favorite, setFavorite] = useState(false);

  useEffect(() => {
    const favorites = storage.getFavorites();
    const index = favorites.indexOf(id);
    setFavorite(index > -1);
  }, [id]);

  const handleClick = event => {
    event.preventDefault();

    const favorites = storage.getFavorites();
    const index = favorites.indexOf(id);

    if (index === -1) {
      favorites.push(id);
      setFavorite(true)
    } else {
      favorites.splice(index, 1);
      setFavorite(false)
    }
    storage.setFavorites(favorites);
  };

  const classNameEnd = favorite ? '-chosen' : '';
  const inFavourites = favorite ? 'В избранном' : 'В избранное';

  return (
    <Fragment>
      {children(handleClick, classNameEnd, inFavourites)}
    </Fragment>
  )
};

export default FavoriteHeart
